'use strict';

var label = require('../util/label');

module.exports = imageReference;
var leftSquareBracket = '[';
var rightSquareBracket = ']';
var exclamationMark = '!';

function imageReference(node) {
  return exclamationMark + leftSquareBracket + (this.encode(node.alt, node) || '') + rightSquareBracket + label(node);
}